import { type LeftTop, type Rect } from "@client/types";

export const getScreenRect = (): Rect => {
  const height = window.innerHeight;
  const width = window.innerWidth;

  return {
    bottom: height,
    right: width,
    left: 0,
    top: 0,
    height,
    width
  };
};

export const isInRect = (rect: Rect, lt: LeftTop): boolean =>
  rect.left <= lt.left && lt.left <= rect.right && rect.top <= lt.top && lt.top <= rect.bottom;

/**
 * Returns screen rect considering scroll offset
 */
export const getScreenOffsetRect = (): Rect => {
  const offsetTop = window.pageYOffset;
  const offsetLeft = window.pageXOffset;
  const height = window.innerHeight;
  const width = window.innerWidth;
  return {
    bottom: offsetTop + height,
    right: offsetLeft + width,
    left: offsetLeft,
    top: offsetTop,
    height,
    width
  };
};

export const getTopRelativeTo = (el: HTMLElement, parentSelector: string): number => {
  const selfRect = el.getBoundingClientRect();
  const parentTop = el.closest(parentSelector)?.getBoundingClientRect().top || 0;
  return selfRect.top - parentTop;
};
